import { useSyncExternalStore } from 'react';
import { getMediaQueryStore } from '@/shared/libs/get-media-query-store';

const noopSubscribe = () => () => {};
const getServerSnapshot = () => false;

export const useMediaQuery = (query) => {
  const store =
    typeof window !== 'undefined' ? getMediaQueryStore(query) : null;

  return useSyncExternalStore(
    store?.subscribe ?? noopSubscribe,
    store?.getSnapshot ?? getServerSnapshot,
    getServerSnapshot
  );
};
